<div id="content" class="container px-0">
  <!-- InstanceBeginEditable name="Main" -->
  <h1>
    Custom Molded Rubber and Gasket Seals Product Index
  </h1>

  <p>
    Our custom-molded rubber and plastic parts and precision metal components use a 
    diverse set of materials and techniques to fit your exact application needs. Browse 
    through our custom-molded gasket and seal offerings below.
  </p>


  <tabset class="py-4">
    <tab customClass="tab-v3">
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Custom Molded" class="tab-image"
            src="/assets/site/assets/catalog_images/Custom Molding temp (S).webp" />
          <p class="pt-2">
            Custom<br />Molded
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/custom-molded-rubber-products.htm']">
                <img alt="Custom Rubber Molding" class="tab-content-image"
                  src="/assets/site/assets/catalog_images/Custom Molding temp (S).webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/custom-molded-rubber-products.htm']">
                  Custom Molded Rubber - Bushings - Stoppers - Bellows - Diaphragms
                </a>
              </p>
              <ul>
                <li>
                  Custom Molded Rubber and Custom Rubber Molding.
                </li>
                <li>
                  Fast and cost effective service from prototype runs to millions.
                </li>
                <li>
                  Some parts quoted in a few hours, sometimes with no tooling fees.
                </li>
                <li>
                  Any rubber material, durometer, color available.
                </li>
                <li>
                  Compression molding, Transfer molding, Injection molding.
                </li>
                <li>
                  Precision Tight Tolernace Molding
                </li>
                <li>
                  Rubber Bushings, Rubber Stoppers, Rubber Tips, Rubber Caps, Rubber Bellows.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/custom-molded-rubber-products.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>

    </tab>

    <tab>
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Custom Molded" class="tab-image" src="/assets/site/images/plastic-pellets-square.webp" />
          <p class="pt-2">
            Custom<br />Plastic<br />Parts
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/custom-plastic-parts.htm']">
                <img alt="Custom Rubber Molding" class="tab-content-image" src="/assets/site/images/plastic-pellets-square.webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/custom-plastic-parts.htm']">
                  Custom Plastic Parts
                </a>
              </p>
              <ul>
                <li>
                  Low-Density Polyethylene
                </li>
                <li>
                  High-Density Polyethylene
                </li>
                <li>
                  ABS (Acrylonitrile Butadiene Styrene)
                </li>
                <li>
                  Nylon
                </li>
                <li>
                  PPSU (Polyphenylsulfone)
                </li>
                <li>
                  Acetal & Delrin
                </li>
                <li>
                  Polycarbonate
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/custom-plastic-parts.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>

    </tab>

    <tab>
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Custom Molded" class="tab-image"
            src="/assets/site/images/metal-parts-square.webp" />
          <p class="pt-2">
            Precision<br />Metal<br />Components
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/precision-metal-components.htm']">
                <img alt="Custom Rubber Molding" class="tab-content-image"
                  src="/assets/site/images/metal-parts-square.webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/precision-metal-components.htm']">
                  Precision Metal Components
                </a>
              </p>
              <ul>
                <li>
                  Die casting
                </li>
                <li>
                  Investment casting
                </li>
                <li>
                  Sand casting
                </li>
                <li>
                  Gravity casting
                </li>
                <li>
                  Forging
                </li>
                <li>
                  Machining
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/precision-metal-components.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>

    </tab>


    <tab>
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Grommets" class="tab-image" src="/assets/site/assets/catalog_images/Grommet (S).webp" />
          <p class="pt-2">
            Grommets
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/rubber-grommets.htm']">
                <img alt="Custom Rubber Grommets" class="tab-content-image" src="/assets/site/assets/catalog_images/Grommet (S).webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/rubber-grommets.htm']">
                  Rubber Grommets
                </a>
              </p>
              <ul>
                <li>
                  Huge inventory of Rubber Grommets
                </li>
                <li>
                  Order Rubber Grommets Online
                </li>
                <li>
                  Mil-Spec Grommets MS35489, AN931, MIL-G-3036 Military Grade Grommets.
                </li>
                <li>
                  Rubber grommets are typically used in bulk-heads or sheet metal holes to protect wires or tubing from
                  sharp edges and vibration.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/rubber-grommets.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>
    </tab>
    <tab>
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Gaskets" class="tab-image" src="/assets/site/assets/catalog_images/Gaskets and Washers (S).webp" />
          <p class="pt-2">
            Gaskets
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/rubber-gaskets.htm']">
                <img alt="Custom Rubber Gaskets and Washers" class="tab-content-image"
                  src="/assets/site/assets/catalog_images/Gaskets and Washers (S).webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/rubber-gaskets.htm']">
                  Cut Gaskets
                </a>
              </p>
              <ul>
                <li>
                  Custom Rubber Gaskets and Non-Metallic Gasket Materials.
                </li>
                <li>
                  Fast and cost effective service from prototype runs to millions.
                </li>
                <li>
                  Gaskets quoted in a few hours, often with no tooling fees.
                </li>
                <li>
                  Any Gasket material durometer, color, Mil-Spec available.
                </li>
                <li>
                  Water Jet Cut Gaskets, Lathe Cut Gaskets, Die Cut Gaskets, Rotary Cut, Kiss Cut.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/rubber-gaskets.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>
    </tab>
    <tab>
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Conductive O-Rings (RFI EMI Shielding)" class="tab-image"
            src="/assets/site/assets/catalog_images/EMI Shielding Gaskets.webp" />
          <p class="pt-2">
            Conductive<br />O-Rings<br />(RFI EMI<br />Shielding)
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/emi-o-rings.htm']">
                <img alt="EMI Gaskets" class="tab-content-image" src="/assets/site/assets/catalog_images/EMI Shielding Gaskets.webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/emi-o-rings.htm']">
                  Conductive O-Rings (RFI EMI Shielding)
                </a>
              </p>
              <ul>
                <li>
                  EMI Shielding O-Rings and EMI Shielding Gaskets.
                </li>
                <li>
                  Conductive O-Rings and Static Dissipative Seals.
                </li>
                <li>
                  View our EMI Shielding Material Selection Guide
                </li>
                <li>
                  Mil-DTL-83528 EMI Shielding Materials
                </li>
                <li>
                  Nickel Graphite Silicone Shielding , Silver Aluminum Silicone Shielding.
                </li>
                <li>
                  Ohmerishield the Chomerics® alternative EMI Shielding Gaskets lower cost similar performance.
                </li>
                <li>
                  Ohmerishield the Laird alternative EMI Shielding Gaskets lower cost similar performance.
                </li>
                <li>
                  Ohmerishield the Schlegel alternative EMI Shielding Gaskets lower cost similar performance.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/emi-o-rings.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>
    </tab>
    <tab>
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Fabric Over Foam EMI Shielding Gaskets" class="tab-image"
            src="/assets/site/assets/catalog_images/Over Foam EMI Shielding.webp" />
          <p class="pt-2">
            Fabric Over<br />Foam EMI<br />Shielding<br />Gaskets
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/fabric-over-foam-emi-gasket.htm']">
                <img alt="EMI Shielding Gaskets" class="tab-content-image"
                  src="/assets/site/assets/catalog_images/Over Foam EMI Shielding.webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/fabric-over-foam-emi-gasket.htm']">
                  Fabric Over Foam EMI Shielding Gaskets
                </a>
              </p>
              <ul>
                <li>
                  Fabric over Foam EMI Shielding Gaskets
                </li>
                <li>
                  Ohmerishield the Chomerics® alternative Fabric over Foam Shielding Gaskets lower cost similar
                  performance.
                </li>
                <li>
                  Ohmerishield the Laird alternative Fabric over Foam Shielding Gaskets lower cost similar performance.
                </li>
                <li>
                  Ohmerishield the Schlegel alternative Fabric over Foam Shielding Gaskets lower cost similar
                  performance.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/fabric-over-foam-emi-gasket.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>
    </tab>
    <tab>
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Sanitary (TriClamp) Gaskets" class="tab-image"
            src="/assets/site/assets/catalog_images/Sanitary Seal Gasket Correct (S).webp" />
          <p class="pt-2">
            Sanitary<br />(TriClamp)<br />Gaskets
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/tri-clamp-sanitary-gasket.htm']">
                <img alt="Sanitary Gaskets" class="tab-content-image"
                  src="/assets/site/assets/catalog_images/Sanitary Seal Gasket Correct (S).webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/tri-clamp-sanitary-gasket.htm']">
                  Sanitary Seals, TriClamp Gaskets, TriClover Fittings
                </a>
              </p>
              <ul>
                <li>
                  Sanitary Gaskets are available for the Food, Beverage, Dairy &amp; Pharmaceutical processing
                  industries.
                </li>
                <li>
                  Sanitary Gaskets are available in Buna-N, Viton, EPDM, Silicone and PTFE.  The materials are FDA
                  compliant and some are USP Class VI certified.
                </li>
                <li>
                  Gaskets are available in a wide variety of configurations.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/tri-clamp-sanitary-gasket.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>
    </tab>
    <tab>
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Fastener Seals (Stat-O-Seal)" class="tab-image"
            src="/assets/site/assets/catalog_images/Washer with Rubber (S).webp" />
          <p class="pt-2">
            Fastener<br />Seals<br />(Stat-O-Seal)
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/rubber-fastener-seals.htm']">
                <img alt="Fastner Seal Gaskets" class="tab-content-image"
                  src="/assets/site/assets/catalog_images/Washer with Rubber (S).webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/rubber-fastener-seals.htm']">
                  Fastener Seals (Stat-O-Seal®), Rubber Bonded to Metal
                </a>
              </p>
              <ul>
                <li>
                  Fastener Seals (Stat-O-Seal®) are designed to seal fastener bolt heads
                </li>
                <li>
                  Fastener Seals (Stat-O-Seal®) are washers with rubber seal moled in
                </li>
                <li>
                  Fastener Seals (Stat-O-Seal®) are available in standard fastener sizes
                </li>
                <li>
                  Custom bonded rubber to metal enclosures (Gask-O-Seal®) for custom applications like door seals with
                  sealing elements molded into a substrate surface
                </li>
              </ul>
              <p>
              </p>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/rubber-fastener-seals.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>
    </tab>
    <tab>
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Bumpers - Feet - Bumpons" class="tab-image"
            src="/assets/site/assets/catalog_images/Bumpers and feet (S).webp" />
          <p class="pt-2">
            Bumpers /<br />Feet /<br />Bumpons
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/bumper-feet.htm']">
                <img alt="Custom Rubber Bumpers" class="tab-content-image"
                  src="/assets/site/assets/catalog_images/Bumpers and feet (S).webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/bumper-feet.htm']">
                  Self Adhesive Bumpers - Rubber Bumper Feet - Bumpons
                </a>
              </p>
              <ul>
                <li>
                  Polyurethane rubber bumper feet for reducing vibration and to prevent damage.
                </li>
                <li>
                  Peel and stick bumper rubber based adhesive backing is standard with acrylic-based available upon
                  request
                </li>
                <li>
                  Our 100% polyurethane rubber bumper feet material has no plasticizers, oils or fillers, which means
                  non-marking unlike others in the market.
                </li>
                <li>
                  Custom shapes, sizes and colors are available upon high volume request.
                </li>
                <li>
                  Made in USA, RoHS and WEEE Compliant
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/bumper-feet.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>
    </tab>
    <tab>
      <ng-template tabHeading>
        <div class="tab-heading">
          <img alt="Rubber Extrusions" class="tab-image"
            src="/assets/site/assets/catalog_images/Custom Extrusions (S).webp" />
          <p class="pt-2">
            Rubber<br />Extrusions
          </p>
        </div>
      </ng-template>
      <table class="productTable mt-3">
        <tbody>
          <tr>
            <td valign="top" >
              <a [routerLink]="['/rubber-extrusions.htm']">
                <img alt="Custom Rubber Extrusions" class="tab-content-image"
                  src="/assets/site/assets/catalog_images/Custom Extrusions (S).webp" />
              </a>
            </td>
            <td width="80%">
              <p>
                <a [routerLink]="['/rubber-extrusions.htm']">
                  Custom Extrusions, X, D, P, e Shapes
                </a>
              </p>
              <ul>
                <li>
                  Custom Rubber Extrusions and rubber tubing are available in a wide range of materials and profiles
                  typically made to order.
                </li>
                <li>
                  Rubber Tubing had low deflection force, high flexibility.
                </li>
                <li>
                  Sponge Rubber Extrusions are used for environmental seals in many types of equipment.
                </li>
                <li>
                  Rubber Tubing can be bonded or vulcanized to form a hollow O-Ring.
                </li>
                <li>
                  Tolerances typically larger than molding.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button class="btn btn-info mr-3" routerLink="/rubber-extrusions.htm">Learn More</button>
              <button class="btn btn-primary" routerLink="/inquiry-quote.htm">Request a Quote</button>
            </td>
          </tr>  
        </tbody>
      </table>
    </tab>
  </tabset>


  <div class="mt-5">
    <app-cta title="Ready to Get the Custom Solution You Need?" 
        [routerLink]="['/inquiry-general.htm']" [bulletPoints]='[]' cta="Contact Us" 
        [textPoints]='["Marco Rubber & Plastics combines multi-industry expertise with deep product knowledge, expert customization and exceptional customer service to provide excellent rubber, plastic, metal or foam gaskets and sealing solutions. Find out how our custom products can serve your needs by connecting with an expert today."]'></app-cta>
  </div>


</div>